import {MOON_250} from '@wandb/weave/common/css/globals.styles';
import {Alert} from '@wandb/weave/components/Alert';
import React from 'react';

import {useFetchRunOutputLogQuery} from '../../../generated/graphql';
import * as RunHelpers from '../../../util/runhelpers';
import {Log} from '../../Log';
import {DEFAULT_LAUNCH_PROJECT_NAME} from '../constants';
import {Agent} from '../utilTypes';

type TabLogsProps = {
  entityName: string;
  agent: Agent;
};

export const TabLogs = ({entityName, agent}: TabLogsProps) => {
  const pollInterval = 10000;
  const projectName = DEFAULT_LAUNCH_PROJECT_NAME;
  const runName = agent.name;

  const queryOutput = useFetchRunOutputLogQuery({
    variables: {
      entityName,
      projectName,
      runName,
    },
    pollInterval,
  });

  if (queryOutput.error) {
    return <Alert severity="error">Error fetching agent details</Alert>;
  }

  const run = queryOutput.data?.project?.run;
  const outputLogFile =
    queryOutput.loading || !run
      ? null
      : RunHelpers.outputLogFile(run.outputLogFile);
  const logLineCount = run?.logLineCount ?? -1;
  return (
    <div
      style={{
        border: `1px solid ${MOON_250}`,
        height: 'calc(100vh - 240px)',
      }}>
      <Log
        entityName={entityName}
        projectName={projectName}
        runName={runName}
        totalLines={logLineCount}
        outputLogFile={outputLogFile}
        pollInterval={pollInterval}
        analyticsLocation="launch-agent-logs"
      />
    </div>
  );
};
